module.exports = __webpack_public_path__ + "static/img/Jesse-McLean.1ad991d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-McLean.jpg
// module id = BB/R
// module chunks = 0